import type { IProductQuestionnaire } from '../../Types/Products/IProductQuestionnaire';

/**
 * When `notesDefaultPermission` was never stored on the questionnaire, gen3 treats the
 * effective default as Editor so invited participants can edit unless an admin sets
 * All users to Read or None. Explicit "None" / "Read" / "Editor" in Cosmos are unchanged.
 */
export function getEffectiveNotesDefaultPermission(
  q: Pick<IProductQuestionnaire, 'notesDefaultPermission'> | undefined
): 'Editor' | 'Read' | 'None' {
  const raw = q?.notesDefaultPermission;
  return raw === undefined || raw === null ? 'Editor' : raw;
}
